import { render } from "./WavetoApp.vue?vue&type=template&id=269f82be&scoped=true"
import script from "./WavetoApp.vue?vue&type=script&lang=js"
export * from "./WavetoApp.vue?vue&type=script&lang=js"

import "./WavetoApp.vue?vue&type=style&index=0&id=269f82be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-269f82be"]])

export default __exports__